import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import Edit from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import Translate from "../../utils/utils";

const headCells = [
    {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
    {id: 'date', label: <Translate id={"TABLE.DATE"}/>},
    {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function FreightForwarderList(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [freightForwarders, setFreightForwarders] = useState([]);
    const initialValues = {name: ""};
    const [freightForwarder, setFreightForwarder] = useState(initialValues);
    const [name, setSearchTerm] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(false);
    const resource = new Resource('freightForwarder');
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const user = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = freightForwarders.filter((item) => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setFreightForwarders(remaining);
    };

    useEffect(() => {
        list()
    }, [page, perPage]);

    const list = () => {
        setIsLoading(true);
        resource.index({
            perPage,
            page,
            name
        })
            .then(response => {
                const {data: {data = {data: []}}} = response;
                const paginationData = data;
                setFreightForwarders(paginationData.data);
                setPagination(paginationData);
                setIsLoading(false);
            }).catch(err => {
            setIsLoading(false);
        });
    };

    const handleCreate = (freightForwarder) => {
        const growersList = [freightForwarder, ...freightForwarders];
        setFreightForwarders(growersList);
    };

    const handleUpdate = (freightForwarder) => {
        const freightForwarderList = freightForwarders.map(item => {
            if (item.id === freightForwarder.id) {
                return freightForwarder;
            }
            return item;
        });
        setFreightForwarders(freightForwarderList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setSearchTerm(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <Edit handleCreate={handleCreate} resource={resource} initialValues={freightForwarder}
                      key={freightForwarder.id}
                      handleUpdate={handleUpdate} onCloseModal={() => setFreightForwarder(initialValues)}
                />
            </div>

            <Search onType={onType} onSubmit={onSearch} module={"Freight Forwarder"} onClear={onClearSearch}
                    disabled={isLoading} value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={freightForwarders.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {freightForwarders.map(freightForwarder => {

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={freightForwarder.id}
                                    >
                                        <TableCell component="th" scope="row">
                                            {freightForwarder.name}
                                        </TableCell>
                                        <TableCell>{freightForwarder.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete'
                                                    onClick={() => {
                                                        setFreightForwarder(freightForwarder)
                                                    }}>
                                                <Translate id={"TABLE.ACTIONS.EDIT"}/>
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`freightForwarder`}
                                                    itemId={freightForwarder.id}
                                                    itemName={freightForwarder.name}
                                                    removeItemInListing={removeItemInListing}
                                                />
                                            </>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]}
                    labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
